import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/pro-light-svg-icons/faCoins';
import { TypedMemo } from '../../../common/types';
import type { BrowseUsageData } from '../hooks/useBrowseUsage';
import { browseCreditMessages as messages } from '../browseMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowsePhone.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BrowseCreditsPillProps {
  usage: BrowseUsageData | undefined;
  onOpen: () => void;
}

/** The credits pill next to the title on a phone (design c1); a tap opens the credits sheet (c3). */
const BrowseCreditsPillComponent: React.FC<BrowseCreditsPillProps> = ({ usage, onOpen }) => {
  const intl = useIntl();
  if (usage === undefined) {
    return null;
  }
  return (
    <button
      type="button"
      className={clsx(styles.pill, usage.left <= 1 && styles.pillWarn)}
      onClick={onOpen}
      aria-label={intl.formatMessage(messages.pillLabel, { left: usage.left, limit: usage.limit })}
      data-testid="browse-credits-pill"
    >
      <FontAwesomeIcon icon={faCoins} />
      {intl.formatMessage(messages.pill, { left: usage.left, limit: usage.limit })}
    </button>
  );
};

export const BrowseCreditsPill = TypedMemo(BrowseCreditsPillComponent);
